
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";
import { GuardTour } from "@/store/guard-tours/types";
import { MapItemData } from "@/store/map-layers/types";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AreaTreeSelect from "@/components/form/AreaTreeSelect.vue";
import SureViewIcon from "@/components/SureViewIcon.vue";
import MapLayerItemListItem from "@/components/guard-tours/MapLayerItemListItem.vue";

const GuardTours = namespace("GuardTours");
const MapLayers = namespace("mapLayers");

@Component({
	components: {
		"area-tree-select": AreaTreeSelect,
		"vue-perfect-scrollbar": VuePerfectScrollbar,
		"sureview-icon": SureViewIcon,
		"map-layer-item-list-item": MapLayerItemListItem
	}
})
export default class GuardTourAreaPicker extends Vue {

	@GuardTours.State selectedAreaId: number;	
	@GuardTours.State mapItemList: MapItemData[];
	@GuardTours.Mutation setAreaSelectedId : (selectedAreaId: number) => void;
	
	@MapLayers.Getter("getMapLayersBounds")	mapLayersBounds!: google.maps.LatLngBoundsLiteral;
	@MapLayers.State(state => state.MapLayer) mapLayers: any;

	private groupIdSelected: number | null = null;
	private filteredMapItems: MapItemData[] = [];
	private mapItemsSearchFilter: string = "";
	private isLoadingMapItems: boolean = false;
	private listRenderLimit: number = 1000;
	private DEFAULT_RENDER_LIST_LIMIT: number = 1000;
	private maximumItemsInThisList: number = 0;

	@Prop()
	private mapItems: MapItemData[];

	@Watch("groupIdSelected")
	public async onGroupIdSelectedChange(areaId): Promise<void> {
		this.listRenderLimit = this.DEFAULT_RENDER_LIST_LIMIT;
		this.setAreaSelectedId(areaId);
	}

	@Watch("mapItems")
	public onMapItemsUpdate() {
		this.renderMapItemList();
	}

	@Watch("selectedAreaId")
	public async onSelectedAreaIdChange(areaId): Promise<void> {
		this.mapItemsSearchFilter = "";
		this.renderMapItemList();
	}

	@Watch("mapItemsSearchFilter")
	public async onMapItemsSearchFilterChange(searchFilter): Promise<void> {
		if (searchFilter && this.mapItems) {
			this.filteredMapItems = this.mapItems.filter((mapItem: MapItemData) =>
				mapItem.title.toLowerCase().includes(searchFilter.toLowerCase())
			);
			this.maximumItemsInThisList = this.filteredMapItems.length;
			this.filteredMapItems = this.filteredMapItems.slice(0, this.listRenderLimit);
		} else {
			this.renderMapItemList();
		}
	}

	@Emit("add-item-to-tour")
	public addItemToGuardTour(item: MapItemData) {}

	private renderMapItemList(newRenderLimit: number = this.DEFAULT_RENDER_LIST_LIMIT) {
		this.isLoadingMapItems = true;

		this.listRenderLimit = this.DEFAULT_RENDER_LIST_LIMIT;
		this.maximumItemsInThisList = 0;

		if (this.mapItems && this.mapItems.length > 0) {
			this.listRenderLimit = newRenderLimit;
			this.maximumItemsInThisList = this.mapItems.length;
			this.filteredMapItems = this.mapItems.slice(0, this.listRenderLimit);
		}

		this.isLoadingMapItems = false;
	}	
}
